import { CharacterCardActions, CharacterCardVariant } from "@next-platform/client-common-spicy-ui";

import { Collection } from "@/types/api";
import { HitItem } from "@/types/hits";

import { CharacterCardDropdownActions } from "../types";
import getDropdownActions from "./getHitDropdownActions";

interface IGetHitLorebookConfigProps {
  lorebook: HitItem;
  t: (key: string) => string;
  translateTag: (tag: string) => string;
  isAuthenticated: boolean;
  characterCardActionsHandler: (action: CharacterCardActions | CharacterCardDropdownActions, characterId: string, isNsfw?: boolean) => void;
  likedLorebooks?: string[];
  onlyUserId?: string | null;
}

/**
 * Returns the lorebook hit config array based on provided parameters.
 * part of it is also being created in LorebookCard component and that is why we have a lot less properties than in the character config
 */
export default function getHitLorebookConfig({
  lorebook,
  t,
  translateTag,
  isAuthenticated,
  characterCardActionsHandler,
  likedLorebooks,
  onlyUserId,
}: IGetHitLorebookConfigProps) {
  const id = lorebook.lorebook_id || lorebook?.id;
  const tags = lorebook?.tags?.map((tag: string) => translateTag(tag));
  const uniqueKey = lorebook?.recommId ? `${id}-rec-${lorebook?.recommId}` : id;

  const isLorebookLiked = !!likedLorebooks?.includes(id as string);
  const isOwnLorebook = !!onlyUserId && lorebook?.creator_user_id === onlyUserId;
  const isFavoriteHidden = !isAuthenticated || isOwnLorebook;

  return {
    id,
    creator_user_id: lorebook.creator_user_id,
    creator_username: lorebook.creator_username,
    num_entries: lorebook.num_entries || 0,
    characterTags: tags,
    name: lorebook.name,
    description: lorebook.description,
    avatar_url: lorebook?.avatar_url,
    avatar_is_nsfw: lorebook.avatar_is_nsfw,
    tags: lorebook?.tags,
    characterCardVariant: CharacterCardVariant.DEFAULT,
    uniqueKey,
    isHidden: false,
    characterActionsState: {
      [CharacterCardActions.FAVORITE]: {
        isDisabled: false,
        isHidden: isFavoriteHidden,
        isLiked: isLorebookLiked,
      },
    },
    characterCardActionsHandler: (action: CharacterCardActions | CharacterCardDropdownActions, charId: string) => {
      characterCardActionsHandler(action, charId, lorebook?.is_nsfw);
    },
    dropdownActions: getDropdownActions({
      t,
      characterCardActionsHandler,
      isAuthenticated,
      id,
      collection: Collection.LOREBOOKS,
    }),
  };
}
